<template>
  <el-container class="live_room" v-if="showRoom">
    <el-main>
      <div class="main">
        <div class="live_video_box">
          <title-bar
            :title="liveroom.liveroom.name"
            :number="liveroom.liveroom.number"
            :time="setTime"
            :status="liveroom ? liveroom.liveroom.status : 0"
            :stage="!isCdn"
            @quit="quit"
          />
          <div class="inner_box">
            <!--老师模块-->
            <div class="teacher_video live_box">
              <div class="video">
                <div class="teacher_live_video" v-show="isCdn">
                  <video id="teacher_live_video_cdn"></video>
                </div>
                <div
                  v-show="!isCdn"
                  id="teacher_live_video"
                  class="teacher_live_video"
                ></div>
              </div>
              <div class="info clearfix">
                <span class="teacher_info">
                  <i :class="['icon', teacherOnline ? 'active' : '']"></i>
                  {{ liveroom.liveroom.teacher.name }}
                </span>
                <span class="audio">
                  <img
                    class="active"
                    src="../../assets/images/live_room/icon_audio.png"
                    alt=""
                  />
                </span>
              </div>
            </div>
            <!--学生自己模块-->
            <div class="student_video live_box">
              <div class="video">
                <img
                  v-if="!loaclVideo"
                  class="video_error"
                  src="../../assets/images/live_room/icon_video_error.png"
                  alt=""
                />
                <video v-else id="local_video" autoplay ref="videos"></video>
              </div>
              <div class="info clearfix">
                <span class="teacher_info">
                  {{ liveroom.student.name }}
                </span>
                <span class="audio">
                  <img
                    v-if="studentLiveAudio"
                    class="active"
                    src="../../assets/images/live_room/icon_audio.png"
                    alt=""
                  />
                  <img
                    v-else
                    style="width: 2vh;"
                    class="close"
                    src="../../assets/images/live_room/icon_audio_close.png"
                    alt=""
                  />
                </span>
              </div>
            </div>
            <!--学生上台视频-->
            <div
              v-show="isCdn"
              v-for="(item, index) in onlineVideo"
              :key="index"
              :id="`cdn_${item.name}`"
              :class="[
                'video',
                'video_cdn',
                'live_box',
                item.name === studentLiveId ? 'my_video' : ''
              ]"
            >
              <div class="video_box">
                <video :id="`video_${item.name}`"></video>
              </div>
              <div class="info clearfix">
                <span class="teacher_info">
                  {{ allUser[item.name] }}
                </span>
                <span class="audio">
                  <img
                    v-if="item.audio === 1"
                    class="active"
                    src="../../assets/images/live_room/icon_audio.png"
                    alt=""
                  />
                  <img
                    v-else
                    style="width: 2vh;"
                    class="close"
                    src="../../assets/images/live_room/icon_audio_close.png"
                    alt=""
                  />
                </span>
              </div>
            </div>
            <div
              v-show="!isCdn"
              v-for="(item, index) in onlineVideo"
              :key="index"
              :class="[
                'video',
                'live_box',
                item.name === studentLiveId ? 'my_video' : ''
              ]"
              :id="item.name"
            >
              <div class="info clearfix">
                <span class="teacher_info">
                  {{ allUser[item.name] }}
                </span>
                <span class="audio">
                  <img
                    v-if="item.audio === 1"
                    class="active"
                    src="../../assets/images/live_room/icon_audio.png"
                    alt=""
                  />
                  <img
                    v-else
                    style="width: 2vh;"
                    class="close"
                    src="../../assets/images/live_room/icon_audio_close.png"
                    alt=""
                  />
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="live_info_box">
          <!--签到模块-->
          <div v-if="showSign" class="student_sign box">
            <div class="title">
              <h1>课题：{{ liveroom.liveroom.name }}</h1>
              <h2>距离上课开始</h2>
            </div>
            <div class="count_down">
              <div class="time">
                <div>{{ count_down.hour[0] }}</div>
                <div>{{ count_down.hour[1] }}</div>
                <div class="center">:</div>
                <div>{{ count_down.min[0] }}</div>
                <div>{{ count_down.min[1] }}</div>
                <div class="center">:</div>
                <div>{{ count_down.sec[0] }}</div>
                <div>{{ count_down.sec[1] }}</div>
              </div>
            </div>
            <div v-if="sign" class="btn">签到成功</div>
            <div v-else class="btn click" @click="studentSign">
              未签到，点击签到
            </div>
          </div>
          <div :class="[courseSize, 'course_box']" v-show="!showSign">
            <div class="miniTool" v-if="showTool">
              <iframe :src="miniToolUrl" ref="miniTool"></iframe>
            </div>
            <!--cocos课件-->
            <div class="cocos box" v-if="showCourse">
              <iframe
                :src="cocosUrl"
                ref="cocosIframe"
                allow="microphone;camera;midi;encrypted-media;"
              ></iframe>
            </div>
            <!--cocosLoading-->
            <div class="cocos_loading" v-if="cocosLoading">
              <img
                src="../../assets/images/live_room/cocos_loading.png"
                alt=""
              />
            </div>
            <!--白板-->
            <div
              id="paint_box"
              :class="[drawEnable ? '' : 'draw_enable', 'white_board', 'box']"
            ></div>
            <!--分享屏幕-->
            <div class="teacher_live_video_aux" v-show="aux">
              <video
                class="aux_main"
                id="teacher_live_video_aux"
                v-show="isCdn"
              ></video>
              <div
                class="aux_main"
                id="teacher_live_video_aux_main"
                v-show="!isCdn"
              ></div>
            </div>
          </div>
          <wb-tool
            v-if="drawEnable"
            :active="toolActive"
            :course-size="courseSize"
            @onSetToolType="onSetToolType"
          >
          </wb-tool>
          <tool-bar
            :is-hand="isHand"
            :course-size="courseSize"
            @onSetHand="onSetHand"
            @quit="quit"
            @onSendMsg="sendMsg"
            :silence="silence"
            :imMsg="imMsg"
            :msgs="msgs"
            :number="studentOnline.length"
            :mine="studentLiveId"
            :teacher="teacherLiveId"
          >
          </tool-bar>
        </div>
      </div>
    </el-main>
    <el-dialog
      class="dialog"
      :visible.sync="dialog.visible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      width="300px"
    >
      <span>{{ dialog.text }}</span>
    </el-dialog>
  </el-container>
</template>

<script>
import TitleBar from "./components/TitleBar";
import WbTool from "@/views/LiveRoom/components/WbTool";
import ToolBar from "@/views/LiveRoom/components/ToolBar";
import flvjs from "flv.js";
import defaultAvatarBoy from "@/assets/images/live_room/default_avatar_boy.png";
import defaultAvatarGirl from "@/assets/images/live_room/default_avatar_girl.png";
import defaultBoyImg from "@/assets/images/live_room/student_default_img_boy.png";
import defaultGirlImg from "@/assets/images/live_room/student_default_img_girl.png";
import baseUrl from "api/api";

export default {
  name: "index",
  components: {
    TitleBar,
    WbTool,
    ToolBar
  },
  data() {
    return {
      liveroomId: this.$route.query.liveroom_id,
      liveroom: {}, // 直播间信息
      defaultAvatarBoy: defaultAvatarBoy,
      defaultAvatarGirl: defaultAvatarGirl,
      defaultBoyImg: defaultBoyImg,
      defaultGirlImg: defaultGirlImg,
      isCdn: true,
      aux: false,
      classStatus: false,
      dialog: {
        visible: false,
        text: ""
      },
      placeholder: [1, 2, 3, 4], // 占位符
      allUser: {},
      apiUrl: "",
      showRoom: false,
      showMsgBox: false,
      showCourse: false, // 显示cocos课件
      silence: false, // 是否禁言
      isHand: false, // 是否举手
      timeout: setTimeout(() => {
        this.quitClassroom();
      }, 1800000), // 老师未开课30分钟自动退出
      ErrorTimeout: null,
      setTime: "00:00:00",
      setTimeA: 0,
      studentOnline: [], // 学生在线人数
      cocosUrl: "", // cocos课件地址
      cocosLoading: false,
      courseConfig: null,
      courseSize: "",
      user: {}, // 当前用户信息
      extra: {}, // 学生信息
      showTool: false,
      miniToolUrl: "",
      group: "",
      teacherLiveId: "",
      teacherOnline: false,
      studentLiveId: "",
      studentLiveAudio: false,
      sdk: {},
      showSign: true, // 签到模块
      sign: false, // 是否签到成功
      count_down: {
        // 倒计时
        hour: [0, 0],
        min: [0, 0],
        sec: [0, 0]
      },
      loaclVideo: false,
      //消息
      msgs: [],
      msgTime: true,
      imMsg: {
        common: {},
        custom: {}
      },
      //音视频及设备
      onlineVideo: [],
      cdnFlv: {},
      enableCamera: true,
      enableMic: true,
      cameraIndex: 0,
      micIndex: 0,
      devices: {
        camera: [],
        mic: []
      },
      //当前用户状态
      STATUS_UNINIT: 0,
      STATUS_UNLOGIN: 1,
      STATUS_LOGINED: 2,
      STATUS_INCLASS: 3,
      status: 0,
      toolActive: 0, // 白板工具激活状态
      drawEnable: false, // 白板是否启用
      //board(涂鸦)
      canRedo: 0,
      canUndo: 0,
      //board(白板操作)
      boardData: {
        currentBoardId: null, //当前白板ID
        boardIdlist: [], //白板ID列表
        current: 0, //当前白板index
        total: 0 //总页数
      },
      //board(文件操作)
      currentFileId: null, // 当前文件Id
      fileInfoList: [], // 所有文件信息
      thumbUrls: [], // 缩略图

      isPushing: 0, // 是否正在推流
      isPushCamera: 0, // 是否推摄像头流
      remoteVideos: {},
      TEduBoard: window.TEduBoard,
      TRTC: window.TRTC,
      localStream: {}
    };
  },
  created() {
    const token = this.$token.get();
    if (token) {
      // 初始化sdk
      this.$http.post("/api/liveroom/tencent-user-sig", {}).then(res => {
        this.$store.commit("initSdk", res.data);
        this.sdk = res.data;
        this.initUser(); // 初始化用户信息
      });
    } else {
      this.$message.error("请先登录!");
      setTimeout(() => {
        this.$router.push(`/?liveroom_id=${this.liveroomId}`);
      }, 2000);
    }
  },
  methods: {
    // 初始化用户信息
    initUser() {
      this.$http.get("/api/users/me").then(res => {
        this.user = res;
        this.studentLiveId = `user-7-${res.platform.id}`;
        this.allUser[this.studentLiveId] = res.platform.name;
        this.joinLiveroom(); // 加入直播间
      });
    },
    // 初始化学生列表
    initStudentList(callback) {
      this.$http
        .get(
          `${this.apiUrl}/api/liveroom/${
            this.liveroomId
          }/student?page=1&per_page=9999`
        )
        .then(res => {
          const arr = res.items.filter(item => item.is_online === 1);
          this.studentOnline = arr;
          console.log("学生在线人数", arr, arr.length);
          res.items.forEach(item => {
            if (item.student && item.student.uuid) {
              const id = `user-7-${item.student.uuid}`;
              this.allUser[id] = item.student.name;
            }
          });
          callback && callback();
        });
    },
    // 加载cocos课件
    loadCourseConfig(id, type, play, course_school_id) {
      switch (type) {
        // AI课件（纯课件）
        case 1:
          this.$http.get(`/api/imkid/course_resource/${id}`).then(res => {
            this.courseConfig = {
              theme: res.courseware_theme_config_original,
              course: res.courseware_config_original,
              videoJson: null,
              videoPath: null
            };
            this.loadCourse(type, play);
          });
          break;
        // AI双师课（课件+视频）
        case 2:
          // eslint-disable-next-line no-case-declarations
          const timestamp = new Date().getTime();
          // eslint-disable-next-line no-case-declarations
          const sign = encodeURI(
            `course_id=${id}&timestamp=${timestamp}1aa2336fbf761ae8866ce691993c51b7d130256d`
          );
          this.$http
            .post("/api/imkid/local_video/download", {
              course_id: id,
              timestamp: timestamp,
              signature: this.$md5(sign)
            })
            .then(res => {
              console.log("cocos download", res.resources);
              const video_url =
                res.video_info.resolution.has_hd_mp4.substring(0, 5) === "https"
                  ? res.video_info.resolution.has_hd_mp4
                  : `https${res.video_info.resolution.has_hd_mp4.substring(4)}`;
              this.courseConfig = {
                theme: res.resources.theme_conf,
                course: res.resources.resource_conf,
                videoJson: res.resources.timeline_conf,
                videoPath: video_url
              };
              this.loadCourse(type, play);
            });
          break;
        // 互动课件（纯课件 新课件）
        case 3:
          this.$http
            .get(`/api/courseware/result/${id}?clients_id=${course_school_id}`)
            .then(res => {
              this.courseConfig = {
                theme: null,
                course: res.data.attr_used.cocos_remote,
                videoJson: null,
                videoPath: null
              };
              this.loadCourse(type, play, 3);
            });
          break;
        default:
          console.log("没有加载cocos课件");
          break;
      }
    },
    loadCourse(type, play, id) {
      const courseType = {
        1: "ykdrecord", // 课件
        2: "ykdpreview" // 视频课
      };
      if (id && id === 3) {
        this.$http
          .get(`${baseUrl.baseUrl}/api/app-packet/cocos/last`)
          .then(res => {
            if (play) {
              this.showCourse = true;
              this.cocosLoading = true;
            }
            const url = res.data.attach.unpack_url;
            const newCourseUrl =
              url.substring(0, 5) === "https"
                ? url.substring(8)
                : url.substring(7);
            this.cocosUrl = `${this.$checkHttp()}${newCourseUrl}?role=student&livescene=ykdrecord&roomid=${
              this.liveroomId
            }&teacherid=${this.liveroom.liveroom.teacher.uuid}&myid=${
              this.liveroom.uuid
            }&clientid=7&platform=h5&env=${
              baseUrl.env
            }&token=Bearer ${this.$token.get()}&server=${baseUrl.server}`;
          });
      } else {
        this.$http
          .get(`${baseUrl.courseUrl}/package_check?production=21&version=0`)
          .then(res => {
            if (play) {
              this.showCourse = true;
              this.cocosLoading = true;
            }
            const url = res.url.substring(0, res.url.lastIndexOf("."));
            const courseUrl =
              url.substring(0, 5) === "https"
                ? url.substring(8)
                : url.substring(7);
            this.cocosUrl = `${this.$checkHttp()}${courseUrl}/cocosKeJian/index.html?role=student&livescene=${
              courseType[type]
            }&roomid=${this.liveroomId}&teacherid=${
              this.liveroom.liveroom.teacher.uuid
            }&myid=${this.liveroom.uuid}&clientid=7&platform=h5&env=${
              baseUrl.env
            }&token=${this.$token.get()}&server=${baseUrl.server}`;
          });
      }
    },
    // 加载cocos小工具
    loadMiniTool(type) {
      this.$http.get("/api/app-packet/cocos_tool/last").then(res => {
        const courseUrl = res.data.attach.unpack_url;
        const newCourseUrl =
          courseUrl.substring(0, 5) === "https"
            ? courseUrl.substring(8)
            : courseUrl.substring(7);
        const url = `${this.$checkHttp()}${newCourseUrl}?room_id=${
          this.liveroomId
        }&role=student&env=dev&type=live&platform=html5&uuid=${
          this.liveroom.uuid
        }&teacher_uuid=${
          this.liveroom.liveroom.teacher.uuid
        }&feature=${type}&name=${this.liveroom.student.name}&avatar=${
          this.liveroom.student.headimgurl
        }&server=${
          baseUrl.server
        }&token=Bearer ${this.$token.get()}&clientid=7`;
        this.showTool = true;
        if (this.miniToolUrl !== url) {
          this.$nextTick(() => {
            this.miniToolUrl = url;
          });
        }
      });
    },
    // 加入直播间
    joinLiveroom() {
      this.$http
        .post(
          `/api/student/join/liveroom/${this.liveroomId}/${
            this.user.platform.id
          }`
        )
        .then(res => {
          this.liveroom = res;
          const id = `user-6-${res.liveroom.teacher.uuid}`;
          this.teacherLiveId = id;
          this.allUser[id] = res.liveroom.teacher.name;
          this.apiUrl = `${this.$checkHttp()}${res.liveroom.api_domain}`;
          if (res.liveroom.status === 3) {
            this.$message.warning("已经下课了~");
            setTimeout(() => {
              this.$router.back();
            }, 3000);
          } else {
            // 上报退出状态
            this.quitReport(() => {
              this.showRoom = true;
              if (
                (res.extend_json_status &&
                  res.extend_json_status.muted === 1) ||
                res.liveroom.is_all_muted === 1
              ) {
                // 判断是否禁言
                this.silence = true;
              }
              // 是否举手
              // if (res.extend_json_status) {
              //   this.isHand = res.extend_json_status.raise_hands === 1;
              // }
              // 判断课件窗口
              const extendStatus = res.liveroom.liveroom_extend_json_status;
              if (extendStatus && extendStatus.course_status) {
                const data = {
                  Maximize: "maximize",
                  Minimize: "minimize",
                  Restore: ""
                };
                this.courseSize = data[extendStatus.course_status];
              }
              // 是否直播中
              if (res.liveroom.status === 2) {
                this.teacherOnline = true;
                this.setLiveTime("start", res.liveroom.begin_time);
                // 加载cocos课件，并播放
                this.loadCourseConfig(
                  res.liveroom.course_id,
                  res.liveroom.course_type,
                  true,
                  res.liveroom.course_school_id
                );
              } else {
                // // 加载cocos课件
                // this.loadCourseConfig(
                //   res.liveroom.course_id,
                //   res.liveroom.course_type,
                //   false,
                //   res.liveroom.course_school_id
                // );
              }
              this.extra = {
                is_online: res.is_online,
                is_sign: res.is_sign,
                is_muted: res.is_muted,
                uuid: res.uuid,
                school_id: res.school_id,
                liveroom_id: res.liveroom_id,
                classes_id: res.classes_id,
                student_id: res.student_id,
                student: {
                  id: res.student_id,
                  uuid: res.uuid,
                  school_id: res.school_id,
                  name: res.student.name,
                  gender: res.student.gender,
                  mobile: res.student.mobile,
                  headimgurl: res.student.headimgurl
                }
              };
              if (res.liveroom.status === 2) {
                this.showSign = false;
                this.classStatus = true;
                clearTimeout(this.timeout);
              } else {
                this.setSignTime(res.liveroom.start_time);
              }
              this.$message.success("进入直播间成功！");
              // 获取学生列表
              this.initStudentList(() => {
                this.init();
              });
            });
          }
        });
    },
    // 倒计时
    setSignTime(val) {
      const time = setInterval(() => {
        let date = this.$setting.showtime(new Date(), new Date(val));
        const hour = date.hour < 10 ? `0${date.hour}` : date.hour;
        const min = date.min < 10 ? `0${date.min}` : date.min;
        const sec = date.sec < 10 ? `0${date.sec}` : date.sec;
        if (date.hour === 0 && date.min === 0 && date.sec === 0) {
          this.count_down = {
            hour: [...String(hour)],
            min: [...String(min)],
            sec: [...String(sec)]
          };
          clearInterval(time);
        } else {
          this.count_down = {
            hour: [...String(hour)],
            min: [...String(min)],
            sec: [...String(sec)]
          };
        }
      }, 1000);
    },
    // 学生签到
    studentSign() {
      const data = {
        uuid: this.liveroom.uuid,
        school_id: this.liveroom.school_id,
        liveroom_id: this.liveroom.liveroom_id,
        classes_id: this.liveroom.classes_id,
        student_id: this.liveroom.student_id
      };
      this.$http.post(`${this.apiUrl}/api/liveroom/sign`, data).then(() => {
        this.$message.success("签到成功!");
        this.sign = true;
        const text = {
          event: "STUDENT_SIGN",
          extra: "签到成功！",
          student_id: this.studentLiveId
        };
        this.tic.sendGroupCustomMessage(JSON.stringify(text)); // 发送签到给老师
      });
    },
    // 学生进入退出直播间上报 type=1 进入 type=2 退出
    studentReport(type) {
      const data = {
        uuid: this.liveroom.uuid,
        school_id: this.liveroom.school_id,
        liveroom_id: this.liveroom.liveroom_id,
        classes_id: this.liveroom.classes_id,
        student_id: this.liveroom.student_id,
        action: type
      };
      this.$http.post(`${this.apiUrl}/api/liveroom/watch`, data).then(res => {
        console.log("学生上报成功", res);
      });
    },
    // 退出上报状态
    quitReport(callback) {
      this.$http
        .patch(
          `${this.apiUrl}/api/liveroom/student/${this.liveroomId}/${
            this.liveroom.student_id
          }/extend_json_status`,
          {
            extend_json_status: {
              whiteboard: 0,
              audio: 0,
              video: 0,
              raise_hands: 0,
              on_stage: 0
            }
          }
        )
        .then(() => {
          console.log("退出状态上报成功");
          callback && callback();
        });
    },
    // 消息列表
    showMessageInBox(fromUserId, text, type, id) {
      const time = this.$moment(new Date()).format("HH:mm:ss");
      if (this.msgTime) {
        this.msgs.push({
          time: time,
          send: fromUserId,
          content: text,
          type: type ? type : "left",
          id: id ? id : null
        });
        this.msgTime = false;
        setTimeout(() => {
          // 设置10分钟显示一次时间
          this.msgTime = true;
        }, 600000);
      } else {
        this.msgs.push({
          time: null,
          send: fromUserId,
          content: text,
          type: type ? type : "left",
          id: id ? id : null
        });
      }
    },
    // 初始化本地摄像头
    initVideo() {
      const _this = this;
      if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
        navigator.mediaDevices
          .getUserMedia({
            video: true
          })
          .then(stream => {
            _this.loaclVideo = true;
            _this.MediaStreamTrack =
              typeof stream.stop === "function"
                ? stream
                : stream.getTracks()[1];
            this.$nextTick(() => {
              const video = _this.$refs.videos;
              video["srcObject"] = stream;
              video.play();
            });
          })
          .catch(err => {
            _this.$message.error(
              "初始化本地摄像头失败，请检查摄像头是否正常！"
            );
            _this.loaclVideo = false;
            console.log("初始化本地摄像头", err);
          });
      } else {
        _this.loaclVideo = false;
      }
    },
    // 初始化业务数据
    initData() {
      this.msgs = [];
      this.devices = {
        camera: [],
        mic: []
      };
      this.cameraIndex = 0;
      this.micIndex = 0;
      this.imMsg = {
        common: {
          data: "",
          toUser: ""
        },
        custom: {
          data: "",
          toUser: ""
        }
      };
      this.canRedo = 0;
      this.canUndo = 0;
      localStorage.setItem("IIC_USERID", this.sdk.user_id);
    },
    // 清除课堂信息
    clearClassInfo() {
      //设备信息
      this.remoteVideos = {};
      this.enableCamera = true;
      this.enableMic = true;
      this.isPushing = 0;
      this.isPushCamera = 0;

      //白板信息
      this.boardData.currentBoardId = null;
      this.boardData.boardIdlist = [];
      this.boardData.current = 0;
      this.boardData.total = 0;
      document.getElementById("paint_box").innerHTML = "";
      // const divvideo = document.querySelector("#video_wrap");
      // while (divvideo.hasChildNodes())
      //   divvideo.removeChild(divvideo.firstChild);
      this.fileInfoList = [];
      this.currentFileId = null;
    },
    // 初始化SDK
    init() {
      if (this.status === this.STATUS_UNINIT) {
        this.initData();
        this.tic = null;
        // eslint-disable-next-line no-undef
        this.tic = new TIC();
        this.tic.init(
          this.sdk.sdk_app_id,
          // eslint-disable-next-line no-undef
          // TIC.CONSTANT.TICDisableModule.TIC_DISABLE_MODULE_NONE, // 不禁用任何模块
          // eslint-disable-next-line no-undef
          TIC.CONSTANT.TICDisableModule.TIC_DISABLE_MODULE_TRTC, // 禁用 TRTC 模块
          res => {
            if (res.code) {
              this.$message({
                showClose: true,
                message: "初始化失败，code:" + res.code + " msg:" + res.desc,
                type: "error"
              });
            } else {
              console.log("TIC", "TIC初始化成功");
              this.status = this.STATUS_UNLOGIN;
              this.login();
            }
          }
        );
      } else {
        this.login();
      }
    },
    // 登录
    login() {
      this.tic.login(
        {
          userId: this.sdk.user_id,
          userSig: this.sdk.user_sig
        },
        res => {
          if (res.code) {
            console.error("登录失败");
            console.error("TIC", "login Failed, code=" + res.code);
          } else {
            this.status = this.STATUS_LOGINED;
            console.log("登录成功");
            // 增加事件监听
            this.addTICMessageListener();
            this.addTICEventListener();
            this.addTICStatusListener();
            this.$nextTick(() => {
              // 加入课堂
              this.joinClassroom();
            });
          }
        }
      );
    },
    // 进入房间
    joinClassroom() {
      if (!this.liveroomId) {
        this.$message.error("房间号不能为空");
        return;
      }
      if (this.status === this.STATUS_INCLASS) {
        this.$message.warning("用户已在直播间！");
        return;
      }
      this.tic.joinClassroom(
        {
          // compatSaas: true,
          classId: this.liveroomId
        },
        {
          // eslint-disable-next-line no-undef
          mode: TIC.CONSTANT.TICClassScene.TIC_CLASS_SCENE_LIVE, // 直播模式，支持1000人以上场景
          // eslint-disable-next-line no-undef
          role: TIC.CONSTANT.TICRoleType.TIC_ROLE_TYPE_AUDIENCE // 观众（观众角色没有发布本地流的权限，只有收看远端流的权限。如果观众想要连麦跟主播互动， 请先通过 switchRole() 切换角色到主播 anchor 后再发布本地流），只在TIC.CONSTANT.TICClassScene.TIC_CLASS_SCENE_LIVE模式下有效
          // role: TIC.CONSTANT.TICRoleType.TIC_ROLE_TYPE_ANCHOR // 主播，只在TIC.CONSTANT.TICClassScene.TIC_CLASS_SCENE_LIVE模式下有效
          // mode: TIC.CONSTANT.TICClassScene.TIC_CLASS_SCENE_VIDEO_CALL // // 实时通话模式，支持1000人以下场景，低延时
        },
        {
          id: "paint_box",
          ratio: "16:9",
          smoothLevel: 0, // 平滑
          boardContentFitMode: 1, // 白板比例
          dataSyncEnable: true, // 是否同步数据
          delaySyncTime: 1000, // 白板延迟同步时间(毫秒)
          toolType: 1, // 涂鸦工具: 默认1 画笔
          globalBackgroundColor: "rgba(255, 255, 255, 0)", // 白板背景颜色
          drawEnable: false // 是否涂鸦
        },
        res => {
          if (res.code) {
            this.$message.error("加入课堂失败");
            console.error(res);
          } else {
            this.status = this.STATUS_INCLASS;
            this.$message.success("加入课堂成功");
            this.showMessageInBox("加入课堂", this.liveroomId, "center");
            window.teduBoard = this.teduBoard = this.tic.getBoardInstance();
            this.trtcClient = this.TRTC.createClient({
              mode: "live",
              sdkAppId: this.sdk.sdk_app_id,
              userId: this.sdk.user_id,
              userSig: this.sdk.user_sig,
              streamId: `${this.sdk.sdk_app_id}_${this.liveroomId}_${
                this.sdk.user_id
              }_main`
            });
            this.trtcClient
              .join({ roomId: this.liveroomId, role: "anchor" })
              .then(() => {
                console.log("进入音视频房间成功");
                // join room success
                this.initTRTCEvent();
              })
              .catch(error => {
                console.error("Join room failed: " + error);
              });
            this.studentReport(1); // 学生进入直播间上报
            setTimeout(() => {
              const text = {
                event: "STUDENT_ENTER_LIVE_ROOM",
                extra: JSON.stringify(this.extra),
                student_id: this.studentLiveId
              };
              this.tic.sendGroupCustomMessage(JSON.stringify(text)); // 发送进入直播间消息
              const pushIndex = this.studentOnline.find(
                item => item.uuid === this.extra.uuid
              );
              if (!pushIndex) {
                this.studentOnline.push(this.extra);
              }
              this.initStudentList(() => {
                this.studentOnline.forEach(item => {
                  if (
                    item.extend_json_status &&
                    item.extend_json_status.on_stage === 1
                  ) {
                    const onlineIndex = this.onlineVideo.find(
                      a => a.name.split("-")[2] == item.uuid
                    );
                    if (!onlineIndex) {
                      this.onlineVideo.push({
                        name: `user-7-${item.uuid}`,
                        audio: item.extend_json_status.audio
                      });
                      this.$nextTick(() => {
                        this.playFlvCdn(
                          `user-7-${item.uuid}`,
                          `video_user-7-${item.uuid}`
                        );
                      });
                    }
                  }
                });
              });
              this.studentSign(); // 学生签到
              this.initVideo(); // 初始化本地摄像头
              this.initBoardEvent(); // 白板监听
              // if (this.liveroom.liveroom.status === 2) {
              //   this.playFlvCdn(this.teacherLiveId, "teacher_live_video_cdn");
              // }
            }, 500);
          }
        }
      );
    },
    // 播放cdn流
    playFlvCdn(userId, divId, aux) {
      if (flvjs.isSupported()) {
        const streamId = `${this.sdk.sdk_app_id}_${this.liveroomId}_${userId}${
          aux ? "" : "_main"
        }`;
        const video = document.getElementById(divId);
        this.cdnFlv[userId] = flvjs.createPlayer(
          {
            type: "flv",
            isLive: true,
            cors: true,
            url: `https://liveplay.yunkedun.com/live/${streamId}.flv`
          },
          {
            enableStashBuffer: false,
            isLive: true
          }
        );
        this.cdnFlv[userId].attachMediaElement(video);
        this.$nextTick(() => {
          setTimeout(() => {
            this.cdnFlv[userId].load();
            this.cdnFlv[userId].play();
          }, 2000);
        });
        this.cdnFlv[userId].on(flvjs.Events.ERROR, errType => {
          // 网络错误
          if (errType === "NetworkError") {
            setTimeout(() => {
              this.playFlvCdn(userId, divId, aux);
            }, 2000);
          }
        });
      }
    },
    // 启动推流(推摄像头)
    startRTC() {
      // 从麦克风和摄像头采集本地音视频流
      // eslint-disable-next-line no-undef
      let cameraStream = TRTC.createStream({
        audio: true,
        video: true,
        mirror: false // 镜像模式
      });
      // 设置视频分辨率等参数
      cameraStream.setVideoProfile("180p");
      if (this.localStream && this.isPushing) {
        // 如果正在推流, 先停止发布流
        this.stopPush(() => {
          this.publishLocalStream(cameraStream);
        });
      } else {
        this.publishLocalStream(cameraStream);
      }
    },
    publishLocalStream(localStream) {
      window.localStream = localStream;
      localStream
        .initialize()
        .catch(error => {
          console.error("failed initialize localStream " + error);
        })
        .then(() => {
          let localVideoWrapEl = document.createElement("div");
          localVideoWrapEl.id = localStream.id_;
          localVideoWrapEl.classList.add("video");
          document
            .getElementById(this.studentLiveId)
            .insertBefore(localVideoWrapEl, null);
          // 插入名称
          // const name = document.createElement("div");
          // name.classList.add("student_name");
          // name.innerHTML = this.allUser[this.studentLiveId];
          // document.getElementById(localStream.id_).appendChild(name);
          // 本地流播放
          localStream.play(localVideoWrapEl, {
            muted: true
          });
          // 发布本地流（远端可收到）
          this.trtcClient &&
            this.trtcClient
              .publish(localStream)
              .then(() => {
                // 本地流发布成功
                this.isPushing = 1; // 正在推流
                this.isPushCamera = true; // 正在推摄像头
                this.localStream = localStream;
                console.log("推流成功");
              })
              .catch(error => {
                console.log(error);
              });
        })
        .catch(error => {
          this.$message.error(`获取本地流失败, ${JSON.stringify(error)}`);
        });
    },
    // 结束推流
    stopPush(callback) {
      if (this.localStream && this.isPushing) {
        this.trtcClient.unpublish(this.localStream).then(() => {
          this.isPushing = 0;
          const dom = document.getElementById(this.localStream.id_);
          this.localStream.stop();
          this.localStream = null;
          if (dom) {
            dom.remove();
          }
          if (
            Object.prototype.toString.call(callback) === "[object Function]"
          ) {
            callback && callback();
          }
        });
      }
    },
    // 摄像头开关
    toggleCamera(type) {
      if (this.localStream) {
        type ? this.localStream.muteVideo() : this.localStream.unmuteVideo();
      }
    },
    // 麦克风开关
    toggleMic(type) {
      if (this.localStream) {
        type ? this.localStream.muteAudio() : this.localStream.unmuteAudio();
      }
    },
    // IM消息监听回调
    addTICMessageListener() {
      this.tic.addTICMessageListener({
        /**
         * 收到C2C文本消息
         * @param fromUserId		发送此消息的用户id
         * @param text				收到消息的内容
         * @param textLen			收到消息的长度
         */
        // eslint-disable-next-line no-unused-vars
        onTICRecvTextMessage: (fromUserId, text, textLen) => {
          console.log("收到C2C文本消息", fromUserId, text);
          this.showMessageInBox(
            this.allUser[fromUserId],
            text,
            "left",
            fromUserId
          );
        },
        /**
         * 收到C2C自定义消息
         * @param fromUserId		发送此消息的用户id
         * @param data				收到消息的内容
         * @param dataLen			收到消息的长度
         */
        // eslint-disable-next-line no-unused-vars
        onTICRecvCustomMessage: (fromUserId, data, textLen) => {
          console.log("收到C2C自定义消息", fromUserId, data);
        },
        /**
         * 收到群文本消息
         * @param fromUserId		发送此消息的用户id
         * @param text				收到消息的内容
         * @param textLen			收到消息的长度
         */
        // eslint-disable-next-line no-unused-vars
        onTICRecvGroupTextMessage: (fromUserId, text, textLen) => {
          console.log("收到群文本消息", fromUserId, text);
          this.showMessageInBox(
            this.allUser[fromUserId],
            text,
            "left",
            fromUserId
          );
        },
        /**
         * 收到群自定义消息
         * @param fromUserId		发送此消息的用户id
         * @param data				收到消息的内容
         * @param dataLen			收到消息的长度
         */
        // eslint-disable-next-line no-unused-vars
        onTICRecvGroupCustomMessage: (fromUserId, data, textLen) => {
          console.log("收到群自定义消息", fromUserId, data);
          const msg = JSON.parse(data);
          const isStudent = msg.student_id === this.studentLiveId; // 是否当前学生
          switch (msg.event) {
            // 教师进入直播间
            case "TEACHER_ENTER_LIVE_ROOM":
              this.showMessageInBox(
                this.allUser[fromUserId],
                "老师进入直播间！",
                "center"
              );
              this.dialog.visible = false;
              if (this.ErrorTimeout) {
                clearTimeout(this.ErrorTimeout);
              }
              if (this.liveroom.liveroom.status === 2) {
                this.playFlvCdn(this.teacherLiveId, "teacher_live_video_cdn");
              }
              this.teacherOnline = true;
              break;
            // 教师离开直播间
            case "TEACHER_LEAVE_LIVE_ROOM":
              document.querySelector("#teacher_live_video_cdn").src = "";
              this.dialog.visible = true;
              this.dialog.text = "老师掉线了，请稍等片刻~";
              // 5分钟后退出
              this.ErrorTimeout = setTimeout(() => {
                this.quitClassroom();
              }, 300000);
              break;
            // 学生进入直播间
            case "STUDENT_ENTER_LIVE_ROOM":
              console.log("进入直播间", msg);
              // eslint-disable-next-line no-case-declarations
              const pushIndex = this.studentOnline.find(
                item => item.uuid == msg.student_id.split("-")[2]
              );
              if (!this.allUser[fromUserId]) {
                const student = JSON.parse(msg.extra).student;
                this.allUser[fromUserId] = student.name;
              }
              if (!pushIndex) {
                this.studentOnline.push(JSON.parse(msg.extra));
              }
              this.showMessageInBox(
                this.allUser[fromUserId],
                "进入直播间！",
                "center"
              );
              break;
            // 学生离开直播间
            case "STUDENT_LEAVE_LIVE_ROOM":
              console.log("离开直播间", msg);
              // eslint-disable-next-line no-case-declarations
              const delIndex = this.studentOnline.findIndex(
                item => item.uuid == msg.student_id.split("-")[2]
              );
              if (delIndex !== -1) {
                this.studentOnline.splice(delIndex, 1);
              }
              this.showMessageInBox(
                this.allUser[fromUserId],
                "离开直播间！",
                "center"
              );
              break;
            // 禁言全体
            case "IM_SILENCE_ALL":
              this.showMessageInBox("提示", "老师开启了全体禁言", "center");
              this.silence = true;
              break;
            // 禁言单个学生
            case "IM_SILENCE_STUDENT":
              if (isStudent) {
                this.showMessageInBox("提示", `您被禁言了`, "center");
                this.silence = true;
              }
              break;
            // 取消禁言全体
            case "IM_CANCEL_SILENCE_ALL":
              this.showMessageInBox("提示", "老师关闭了全体禁言", "center");
              this.silence = false;
              break;
            // 取消禁言单个学生
            case "IM_CAnCEL_SILENCE_STUDENT":
              if (isStudent) {
                this.showMessageInBox("提示", `老师取消了您的禁言`, "center");
                this.silence = false;
              }
              break;
            // 开始上课
            case "CLASS_BEGINS":
              this.showMessageInBox("提示", "开始上课！", "center");
              this.playFlvCdn(this.teacherLiveId, "teacher_live_video_cdn");
              clearTimeout(this.timeout);
              this.showSign = false;
              this.classStatus = true;
              this.setLiveTime("start");
              // eslint-disable-next-line no-case-declarations
              const type = [1, 2, 3];
              if (type.includes(this.liveroom.liveroom.course_type)) {
                this.showCourse = true;
              }
              // 加载cocos课件，并播放
              this.loadCourseConfig(
                this.liveroom.liveroom.course_id,
                this.liveroom.liveroom.course_type,
                true,
                this.liveroom.liveroom.course_school_id
              );
              break;
            // 下课
            case "FINISH_CLASS":
              this.classStatus = false;
              this.dialog.visible = false;
              this.$message({
                message: "老师已经下课！",
                type: "warning",
                duration: 5000
              });
              this.setLiveTime("end");
              setTimeout(() => {
                this.quitClassroom();
              }, 10000);
              break;
            // 打开小工具
            case "OPEN_ANSWER_MACHINE":
              // eslint-disable-next-line no-case-declarations
              const feature = JSON.parse(msg.extra).type || "answer";
              this.loadMiniTool(feature);
              break;
            // 关闭小工具
            case "CLOSE_ANSWER_MACHINE":
              this.showTool = false;
              this.miniToolUrl = "";
              break;
            // 分组消息
            case "ANSWER_MACHINE_GROUP_INFO":
              // eslint-disable-next-line no-case-declarations
              const group = JSON.parse(msg.extra);
              group.forEach(item => {
                item.students.forEach(a => {
                  if (a == this.liveroom.uuid) {
                    this.group = item.group;
                  }
                });
              });
              this.loadMiniTool("grouping");
              break;
            // 学生举手
            case "RAISE_HANDS":
              // this.showMessageInBox(
              //   this.allUser[fromUserId],
              //   "举手！",
              //   "center"
              // );
              break;
            // 学生取消举手
            case "CANCEL_RAISE_HANDS":
              // this.showMessageInBox(
              //   this.allUser[fromUserId],
              //   "取消举手！",
              //   "center"
              // );
              if (isStudent) {
                this.isHand = false;
                // 上报取消举手
                this.$http
                  .patch(
                    `${this.apiUrl}/api/liveroom/student/${this.liveroomId}/${
                      this.liveroom.student_id
                    }/extend_json_status`,
                    {
                      extend_json_status: {
                        raise_hands: 0
                      }
                    }
                  )
                  .then(() => {
                    console.log("取消举手状态上报成功");
                  });
              }
              break;
            // 清空学生举手
            case "CLEAR_RAISE_HANDS":
              this.showMessageInBox("提示", "老师清空了学生的举手！", "center");
              this.isHand = false;
              break;
            // 学生签到
            case "STUDENT_SIGN":
              // this.showMessageInBox(
              //   this.allUser[fromUserId],
              //   "签到成功！",
              //   "center"
              // );
              break;
            // 授予学生连麦(上台)
            case "GRANT_STUDENT_LIVE":
              // eslint-disable-next-line no-case-declarations
              const onlineIndex = this.onlineVideo.find(
                item => item.name === msg.student_id
              );
              if (!onlineIndex) {
                this.onlineVideo.push({
                  name: msg.student_id,
                  audio: 1
                });
                this.$forceUpdate();
              }
              if (isStudent) {
                for (let item in this.cdnFlv) {
                  this.cdnFlv[item].destroy();
                  delete this.cdnFlv[item];
                }
                this.$http
                  .patch(
                    `${this.apiUrl}/api/liveroom/student/${this.liveroomId}/${
                      this.liveroom.student_id
                    }/extend_json_status`,
                    {
                      extend_json_status: {
                        audio: 1,
                        video: 1,
                        on_stage: 1
                      }
                    }
                  )
                  .then(() => {
                    console.log("上台状态上报成功");
                    this.isCdn = false;
                    this.studentLiveAudio = true;
                    this.tic.setTEBDelaySyncTime(0);
                    this.trtcClient = this.TRTC.createClient({
                      mode: "live",
                      sdkAppId: this.sdk.sdk_app_id,
                      userId: this.sdk.user_id,
                      userSig: this.sdk.user_sig,
                      streamId: `${this.sdk.sdk_app_id}_${this.liveroomId}_${
                        this.sdk.user_id
                      }_main`
                    });
                    this.trtcClient
                      .join({ roomId: this.liveroomId, role: "anchor" })
                      .then(() => {
                        console.log("进入音视频房间成功");
                        // join room success
                        this.initTRTCEvent();
                        this.startRTC(); // 开始推流
                      })
                      .catch(error => {
                        console.error("Join room failed: " + error);
                      });
                  });
              } else {
                const onlineIndex = this.onlineVideo.find(
                  item => item.name == msg.student_id
                );
                if (!onlineIndex) {
                  this.onlineVideo.push({
                    name: msg.student_id,
                    audio: 1
                  });
                }
                if (this.isCdn) {
                  this.$nextTick(() => {
                    this.playFlvCdn(msg.student_id, `video_${msg.student_id}`);
                  });
                }
              }
              break;
            // 取消学生连麦(下台)
            case "CANCEL_STUDENT_LIVE":
              // eslint-disable-next-line no-case-declarations
              const delOnlineIndex = this.onlineVideo.findIndex(
                item => item.name === msg.student_id
              );
              if (delOnlineIndex !== -1) {
                this.onlineVideo.splice(delOnlineIndex, 1); // 移除流
                this.$forceUpdate();
              }
              if (isStudent) {
                this.$http
                  .patch(
                    `${this.apiUrl}/api/liveroom/student/${this.liveroomId}/${
                      this.liveroom.student_id
                    }/extend_json_status`,
                    {
                      extend_json_status: {
                        audio: 0,
                        video: 0,
                        on_stage: 0
                      }
                    }
                  )
                  .then(() => {
                    console.log("下台状态上报成功");
                    this.tic.setTEBDelaySyncTime(1000);
                    if (this.localStream && this.isPushing) {
                      // 如果正在推流, 先停止发布流
                      this.stopPush(() => {
                        // this.trtcClient
                        //   .leave()
                        //   .then(() => {
                        //     console.log("音视频退房成功");
                        //   })
                        //   .catch(error => {
                        //     console.error("退房失败" + error);
                        //   });
                      });
                    } else {
                      // this.trtcClient
                      //   .leave()
                      //   .then(() => {
                      //     console.log("音视频退房成功");
                      //   })
                      //   .catch(error => {
                      //     console.error("退房失败" + error);
                      //   });
                    }
                    this.isCdn = true;
                    this.studentLiveAudio = false;
                    setTimeout(() => {
                      this.playFlvCdn(
                        this.teacherLiveId,
                        "teacher_live_video_cdn"
                      );
                      this.onlineVideo.forEach(item => {
                        this.playFlvCdn(item.name, `video_${item.name}`);
                      });
                      if (this.aux) {
                        this.playFlvCdn(
                          `${this.teacherLiveId}_aux`,
                          "teacher_live_video_aux",
                          true
                        );
                      }
                    }, 2000);
                  });
              } else {
                setTimeout(() => {
                  if (this.isCdn) {
                    for (let item in this.cdnFlv) {
                      if (item !== this.teacherLiveId) {
                        this.cdnFlv[item].destroy();
                        delete this.cdnFlv[item];
                      }
                    }
                    this.$nextTick(() => {
                      this.onlineVideo.forEach(item => {
                        this.playFlvCdn(item.name, `video_${item.name}`);
                      });
                    });
                  }
                }, 2000);
              }
              break;
            // 禁掉学生视频
            case "MUTE_STUDENT_VIDEO":
              if (isStudent) {
                this.showMessageInBox("提示", "您被禁用视频了", "center");
                this.toggleCamera(true); // 禁用视频
              }
              break;
            // 取消禁掉学生视频
            case "UN_MUTE_STUDENT_VIDEO":
              if (isStudent) {
                this.showMessageInBox(
                  "提示",
                  "老师取消了您的禁用视频",
                  "center"
                );
                this.toggleCamera(false); // 取消禁用视频
              }
              break;
            // 禁掉学生音频
            case "MUTE_STUDENT_AUDIO":
              if (isStudent) {
                this.showMessageInBox("提示", "您被禁用麦克风了", "center");
                this.studentLiveAudio = false;
                this.toggleMic(true); // 禁用音频
              }
              // eslint-disable-next-line no-case-declarations
              const muteIndex = this.onlineVideo.findIndex(
                item => item.name === msg.student_id
              );
              this.onlineVideo[muteIndex].audio = 0;
              break;
            // 取消禁掉学生音频
            case "UN_MUTE_STUDENT_AUDIO":
              if (isStudent) {
                this.showMessageInBox(
                  "提示",
                  "老师取消了您的禁用麦克风",
                  "center"
                );
                this.toggleMic(false); // 取消禁用音频
                this.studentLiveAudio = true;
              }
              // eslint-disable-next-line no-case-declarations
              const unMuteIndex = this.onlineVideo.findIndex(
                item => item.name === msg.student_id
              );
              this.onlineVideo[unMuteIndex].audio = 1;
              break;
            // 授予学生白板权限
            case "GRANT_STUDENT_BOARD":
              if (isStudent) {
                this.showMessageInBox(
                  "提示",
                  "老师授权了您的白板权限",
                  "center"
                );
                this.onSetTool(true, 1);
                this.onSetToolType(1);
              }
              break;
            // 取消学生白板权限
            case "CANCEL_STUDENT_BOARD":
              if (isStudent) {
                this.showMessageInBox(
                  "提示",
                  "老师取消了您的白板权限",
                  "center"
                );
                this.onSetTool(false, 0);
              }
              break;
            // 最大化白板
            case "Maximize":
              this.courseSize = "maximize";
              this.$nextTick(() => {
                this.teduBoard.resize();
              });
              break;
            // 最小化白板
            case "Minimize":
              this.courseSize = "minimize";
              break;
            // 重置窗口白板
            case "Restore":
              this.courseSize = "";
              this.$nextTick(() => {
                this.teduBoard.resize();
              });
              break;
            default:
              console.log("收到群自定义消息", fromUserId, data);
              break;
          }
        },
        /**
         * 所有消息
         * @param msg	IM消息体
         * @note 所有收到的消息都会在此回调进行通知，包括前面已经封装的文本和自定义消息（白板信令消息除外）
         */
        onTICRecvMessage(msg) {
          console.log("所有消息", msg);
        }
      });
    },
    // 事件监听回调
    addTICEventListener() {
      this.tic.addTICEventListener({
        // 监听进入课堂
        onTICMemberJoin: members => {
          console.log(`tic监听进入课堂: ${members}`);
          this.showMessageInBox(members.join(","), "进入课堂", "center");
        },
        // 监听退出课堂
        onTICMemberQuit: members => {
          console.log(`tic监听退出课堂: ${members}`);
          this.showMessageInBox(members.join(","), "退出课堂", "center");
        },
        // 监听解散课堂
        onTICClassroomDestroy: () => {
          console.log(`tic监听解散课堂`);
          this.$message.warning("老师解散了课堂！");
        },
        // 监听课堂创建
        onTICTrtcClientCreated: () => {
          console.log(`trtcclient创建成功`);
        }
      });
    },
    // IM状态监听回调
    addTICStatusListener() {
      this.tic.addTICStatusListener({
        onTICForceOffline: () => {
          // eslint-disable-next-line no-alert
          this.$alert(`其他地方登录，被T了`, {
            showClose: false,
            confirmButtonText: "确定",
            callback: () => {
              this.$token.remove();
              this.$router.push(`/?liveroom_id=${this.liveroomId}`);
            }
          });
          this.status = this.STATUS_UNLOGIN;
          this.clearClassInfo();
          console.log("TIC", "onTICForceOffline " + this.roomID);
        }
      });
    },
    // TRTC事件
    initTRTCEvent() {
      // 远端流添加事件，当远端用户发布流后会收到该通知。
      this.trtcClient.on("stream-added", event => {
        const remoteStream = event.stream;
        const remoteUserId = remoteStream.getUserId();
        console.log(
          "远端流添加事件，当远端用户发布流后会收到该通知。received a remoteStream ID: " +
            remoteStream.getId() +
            " from user: " +
            remoteUserId
        );
        // 若需要观看该远端流，则需要订阅它，默认会自动订阅
        this.trtcClient.subscribe(remoteStream);
      });
      // 远端流移除事件，当远端用户取消发布流后会收到该通知。
      this.trtcClient.on("stream-removed", event => {
        const remoteStream = event.stream;
        const type = event.stream.getType();
        console.log(
          "远端流移除事件，当远端用户取消发布流后会收到该通知。remoteStream ID: " +
            remoteStream.getId() +
            " has been removed"
        );
        if (!this.isCdn) {
          // 停止播放并删除相应<video>标签
          remoteStream.stop();
          const dom = document.getElementById(remoteStream.getId());
          if (dom) {
            dom.remove();
          }
        } else {
          if (type === "auxiliary") {
            this.cdnFlv[`${this.teacherLiveId}_aux`].destroy();
            delete this.cdnFlv[`${this.teacherLiveId}_aux`];
          }
        }
        if (type === "auxiliary") {
          this.aux = false;
        }
      });
      // 远端流更新事件，当远端用户添加、移除或更换音视频轨道后会收到该通知。
      this.trtcClient.on("stream-updated", event => {
        const remoteStream = event.stream;
        console.log(
          "远端流更新事件，当远端用户添加、移除或更换音视频轨道后会收到该通知。remoteStream ID: " +
            remoteStream.getId() +
            " was updated hasAudio: " +
            remoteStream.hasAudio() +
            " hasVideo: " +
            remoteStream.hasVideo()
        );
      });
      // 远端流订阅成功事件，调用 subscribe() 成功后会触发该事件。
      this.trtcClient.on("stream-subscribed", event => {
        console.log(
          "远端流订阅成功事件，调用 subscribe() 成功后会触发该事件。"
        );
        const type = event.stream.getType();
        if (type === "auxiliary") {
          this.aux = true;
        }
        if (!this.isCdn) {
          const remoteStream = event.stream;
          // 远端流订阅成功，在HTML页面中创建一个<video>标签，假设该标签ID为‘remote-video-view’
          // 播放该远端流
          let remoteVideoWrapEl = document.createElement("div");
          remoteVideoWrapEl.id = remoteStream.getId();
          if (type === "auxiliary") {
            let auxEl = document.createElement("div");
            auxEl.id = remoteStream.getId();
            document
              .querySelector("#teacher_live_video_aux_main")
              .insertBefore(auxEl, null);
            remoteStream.play(auxEl);
            return;
          }
          if (remoteStream.userId_ === this.teacherLiveId) {
            remoteVideoWrapEl.classList.add("teacher_live_video_main");
            document
              .querySelector("#teacher_live_video")
              .insertBefore(remoteVideoWrapEl, null);
            remoteStream.play(remoteVideoWrapEl);
          } else {
            const onlineIndex = this.onlineVideo.find(
              item => item.name === remoteStream.userId_
            );
            if (!onlineIndex) {
              this.onlineVideo.push({
                name: remoteStream.userId_,
                audio: 1
              });
              this.$forceUpdate();
            }
            // remoteVideoWrapEl.classList.add("video");
            // document
            //   .querySelector("#video_wrap") // student_live_video
            //   .insertBefore(remoteVideoWrapEl, null);
            // // 插入名称
            // const name = document.createElement("div");
            // name.classList.add("student_name");
            // name.innerHTML = this.allUser[remoteStream.userId_];
            // document.getElementById(remoteStream.getId()).appendChild(name);
            // remoteStream.play(remoteVideoWrapEl);
            this.$nextTick(() => {
              remoteVideoWrapEl.style.width = "100%";
              remoteVideoWrapEl.style.height = "100%";
              document
                .getElementById(remoteStream.userId_) // student_live_video
                .insertBefore(remoteVideoWrapEl, null);
              remoteStream.play(remoteVideoWrapEl);
            });
          }
        } else {
          if (type === "auxiliary") {
            this.playFlvCdn(
              `${this.teacherLiveId}_aux`,
              "teacher_live_video_aux",
              true
            );
          }
        }
      });
      // WebSocket 信令通道连接状态变化事件
      this.trtcClient.on("connection-state-changed", event => {
        console.log(
          "WebSocket 信令通道连接状态变化事件connection-state-changed:",
          event.state
        );
      });
      // 远端用户进房通知，只有主动推流的远端用户进房才会收到该通知。
      this.trtcClient.on("peer-join", event => {
        console.log(
          "远端用户进房通知，只有主动推流的远端用户进房才会收到该通知。peer-join",
          event
        );
        // eslint-disable-next-line no-unused-vars
        const userId = event.userId;
      });
      // 远端用户退房通知，只有主动推流的远端用户退房才会收到该通知。
      this.trtcClient.on("peer-leave", event => {
        console.log(
          "远端用户退房通知，只有主动推流的远端用户退房才会收到该通知。peer-leave",
          event
        );
        if (!this.isCdn) {
          // eslint-disable-next-line no-unused-vars
          const userId = event.userId;
          setTimeout(() => {
            if (userId === this.teacherLiveId && this.classStatus) {
              this.teacherOnline = false;
              this.dialog.visible = true;
              this.dialog.text = "老师掉线了，请稍等片刻~";
              // 5分钟后退出
              this.ErrorTimeout = setTimeout(() => {
                this.quitClassroom();
              }, 300000);
            }
          }, 1000);
        }
      });
      // 远端用户禁用音频通知。
      this.trtcClient.on("mute-audio", event => {
        console.log("远端用户禁用音频通知。mute-audio", event);
        const userId = event.userId;
        console.log(`${userId}关闭了麦克风`);
      });
      // 远端用户禁用视频通知。
      this.trtcClient.on("mute-video", event => {
        console.log("远端用户禁用视频通知。mute-video", event);
        const userId = event.userId;
        console.log(`${userId}关闭了摄像头`);
      });
      // 远端用户启用音频通知。
      this.trtcClient.on("unmute-audio", event => {
        console.log("远端用户启用音频通知。unmute-audio", event);
        const userId = event.userId;
        console.log(`${userId}打开了麦克风`);
      });
      // 远端用户启用视频通知。
      this.trtcClient.on("unmute-video", event => {
        console.log("远端用户启用视频通知。unmute-video", event);
        const userId = event.userId;
        console.log(`${userId}打开了摄像头`);
      });
      // 客户端错误事件，当出现不可恢复错误后 Client 会通过该事件上报。
      this.trtcClient.on("error", error => {
        console.error(
          "客户端错误事件，当出现不可恢复错误后 Client 会通过该事件上报。client error observed: " +
            error
        );
        // eslint-disable-next-line no-unused-vars
        const errorCode = error.getCode();
        console.log("error", errorCode);
        // 根据ErrorCode列表查看详细错误原因。
        // this.$message.error(
        //   "当出现不可恢复的错误，请刷新或退出重新打开浏览器！"
        // );
      });
    },
    // 监听白板事件（按需监听）
    initBoardEvent() {
      const teduBoard = this.teduBoard;
      // 撤销状态改变
      teduBoard.on(
        this.TEduBoard.EVENT.TEB_OPERATE_CANUNDO_STATUS_CHANGED,
        enable => {
          this.canUndo = enable ? 1 : 0;
          console.log(
            "======================:  ",
            "TEB_OPERATE_CANUNDO_STATUS_CHANGED",
            enable ? "可撤销" : "不可撤销"
          );
        }
      );

      // 重做状态改变
      teduBoard.on(
        this.TEduBoard.EVENT.TEB_OPERATE_CANREDO_STATUS_CHANGED,
        enable => {
          this.canRedo = enable ? 1 : 0;
          console.log(
            "======================:  ",
            "TEB_OPERATE_CANREDO_STATUS_CHANGED",
            enable ? "可恢复" : "不可恢复"
          );
        }
      );

      // 新增白板
      teduBoard.on(this.TEduBoard.EVENT.TEB_ADDBOARD, (boardIds, fid) => {
        console.log(
          "======================:  ",
          "TEB_ADDBOARD",
          " boardIds:",
          boardIds,
          " fid:",
          fid
        );
        this.proBoardData();
      });

      // 白板同步数据回调(收到该回调时需要将回调数据通过信令通道发送给房间内其他人，接受者收到后调用AddSyncData接口将数据添加到白板以实现数据同步)
      // TIC已经处理好了，可忽略该事件
      teduBoard.on(this.TEduBoard.EVENT.TEB_SYNCDATA, () => {
        console.log("======================:  ", "TEB_SYNCDATA");
      });

      // 收到白板初始化完成事件后，表示白板已处于正常工作状态（此时白板为空白白板，历史数据尚未拉取完成）
      teduBoard.on(this.TEduBoard.EVENT.TEB_INIT, () => {
        console.log("======================:  ", "TEB_INIT");
        console.log("TIC", "onTEBInit finished");
      });

      teduBoard.on(this.TEduBoard.EVENT.TEB_HISTROYDATA_SYNCCOMPLETED, () => {
        console.log(
          "======================:  ",
          "TEB_HISTROYDATA_SYNCCOMPLETED"
        );
        console.log("TIC", "onTEBHistory Sync Completed finished");

        // setTimeout(() => {
        //   teduBoard.addImage('https://main.qcloudimg.com/raw/5c11f1a14f74b00988c5c43dddff2d41.png');
        //   // teduBoard.addImage('https://main.qcloudimg.com/raw/ea3692fd322dbcc7d86c3fc3cc6d3c59.jpg');
        // }, 2000);
      });

      // 白板错误回调
      teduBoard.on(this.TEduBoard.EVENT.TEB_ERROR, (code, msg) => {
        console.error(
          "======================:  ",
          "TEB_ERROR",
          " code:",
          code,
          " msg:",
          msg
        );
        // this.showMessageInBox("TIC", "onTEBError code=" + code + " msg:" + msg);
      });

      // 白板警告回调
      teduBoard.on(this.TEduBoard.EVENT.TEB_WARNING, (code, msg) => {
        console.error(
          "======================:  ",
          "TEB_WARNING",
          " code:",
          code,
          " msg:",
          msg
        );
        // this.showMessageInBox(
        //   "TIC",
        //   "onTEBWarning code=" + code + " msg:" + msg
        // );
      });

      // 图片状态加载回调
      teduBoard.on(
        this.TEduBoard.EVENT.TEB_IMAGE_STATUS_CHANGED,
        (status, data) => {
          console.log(
            "======================:  ",
            "TEB_IMAGE_STATUS_CHANGED",
            " status:",
            status,
            " data:",
            data
          );
        }
      );

      // 删除白板页回调
      teduBoard.on(this.TEduBoard.EVENT.TEB_DELETEBOARD, (boardIds, fid) => {
        console.log(
          "======================:  ",
          "TEB_DELETEBOARD",
          " boardIds:",
          boardIds,
          " fid:",
          fid
        );
        this.proBoardData();
      });

      // 跳转白板页回调
      teduBoard.on(this.TEduBoard.EVENT.TEB_GOTOBOARD, (boardId, fid) => {
        console.log(
          "======================:  ",
          "TEB_GOTOBOARD",
          " boardId:",
          boardId,
          " fid:",
          fid
        );
        this.proBoardData();
      });

      // ppt动画步数改变回调
      teduBoard.on(this.TEduBoard.EVENT.TEB_GOTOSTEP, (step, count) => {
        console.log(
          "======================:  ",
          "TEB_GOTOSTEP",
          " step:",
          step,
          " count:",
          count
        );
      });

      // 增加H5动画PPT文件回调
      teduBoard.on(this.TEduBoard.EVENT.TEB_ADDH5PPTFILE, fid => {
        console.log(
          "======================:  ",
          "TEB_ADDH5PPTFILE",
          " fid:",
          fid
        );
        this.proBoardData();
      });

      // 增加文件回调
      teduBoard.on(this.TEduBoard.EVENT.TEB_ADDFILE, fid => {
        console.log("======================:  ", "TEB_ADDFILE", " fid:", fid);
        this.proBoardData();
      });

      // 增加转码文件回调
      teduBoard.on(this.TEduBoard.EVENT.TEB_ADDTRANSCODEFILE, fid => {
        console.log(
          "======================:  ",
          "TEB_ADDTRANSCODEFILE",
          " fid:",
          fid
        );
        this.proBoardData();
      });

      // 删除文件回调
      teduBoard.on(this.TEduBoard.EVENT.TEB_DELETEFILE, fid => {
        console.log(
          "======================:  ",
          "TEB_DELETEFILE",
          " fid:",
          fid
        );
        this.proBoardData();
      });

      // 文件上传状态
      teduBoard.on(
        this.TEduBoard.EVENT.TEB_FILEUPLOADSTATUS,
        (status, data) => {
          console.log(
            "======================:  ",
            "TEB_FILEUPLOADSTATUS",
            status,
            data
          );
          if (status === 1) {
            this.showTip("上传成功");
          } else {
            this.showTip("上传失败");
          }
          document.getElementById("file_input").value = "";
        }
      );

      // 切换文件回调
      teduBoard.on(this.TEduBoard.EVENT.TEB_SWITCHFILE, fid => {
        console.log(
          "======================:  ",
          "TEB_SWITCHFILE",
          " fid:",
          fid
        );
        if (fid === "#1573462129974") {
          teduBoard.gotoBoard("web_tic_10_1573462130_8_#1573462129974");
        } else if (fid === "#1573218991727") {
          teduBoard.gotoBoard(
            "miniprogram_miniprogram_tic_201_1573218991_3_#1573218991727"
          );
        }
        this.proBoardData();
      });

      // 上传背景图片的回调
      teduBoard.on(
        this.TEduBoard.EVENT.TEB_SETBACKGROUNDIMAGE,
        (fileName, fileUrl, userData) => {
          console.log(
            "======================:  ",
            "TEB_SETBACKGROUNDIMAGE",
            "  fileName:",
            fileName,
            "  fileUrl:",
            fileUrl,
            " userData:",
            userData
          );
        }
      );

      // 文件上传进度
      teduBoard.on(this.TEduBoard.EVENT.TEB_FILEUPLOADPROGRESS, data => {
        console.log(
          "======================:  ",
          "TEB_FILEUPLOADPROGRESS:: ",
          data
        );
        this.showTip("上传进度:" + parseInt(data.percent * 100) + "%");
      });

      // H5背景加载状态
      teduBoard.on(
        this.TEduBoard.EVENT.TEB_H5BACKGROUND_STATUS_CHANGED,
        (status, data) => {
          console.log(
            "======================:  ",
            "TEB_H5BACKGROUND_STATUS_CHANGED:: status:",
            status,
            "  data:",
            data
          );
        }
      );

      // 转码进度
      teduBoard.on(this.TEduBoard.EVENT.TEB_TRANSCODEPROGRESS, res => {
        console.log(
          "=======  TEB_TRANSCODEPROGRESS 转码进度：",
          JSON.stringify(res)
        );
        if (res.code) {
          this.showErrorTip(
            "转码失败code:" + res.code + " message:" + res.message
          );
        } else {
          let status = res.status;
          if (status === "ERROR") {
            this.showErrorTip("转码失败");
          } else if (status === "UPLOADING") {
            this.showTip("上传中，当前进度:" + parseInt(res.progress) + "%");
          } else if (status === "CREATED") {
            this.showTip("创建转码任务");
          } else if (status === "QUEUED") {
            this.showTip("正在排队等待转码");
          } else if (status === "PROCESSING") {
            this.showTip("转码中，当前进度:" + res.progress + "%");
          } else if (status === "FINISHED") {
            this.showTip("转码完成");
            this.teduBoard.addTranscodeFile({
              url: res.resultUrl,
              title: res.title,
              pages: res.pages,
              resolution: res.resolution
            });
          }
        }
      });
    },
    // 白板事件回调处理
    proBoardData() {
      this.fileInfoList = this.teduBoard.getFileInfoList();
      this.currentFileId = this.teduBoard.getCurrentFile();
      this.thumbUrls = this.teduBoard.getThumbnailImages(this.currentFileId);
      var fileInfo = this.teduBoard.getFileInfo(this.currentFileId);
      if (fileInfo) {
        this.boardData = {
          currentBoardId: this.currentFileId,
          boardIdlist: this.teduBoard.getFileBoardList(this.currentFileId),
          current: fileInfo.currentPageIndex + 1,
          total: fileInfo.pageCount
        };
      }
      // this.$nextTick(() => {
      //   this.onSetBackgroundColor("rgba(255, 255, 255, 0)");
      //   this.onSetTool(false);
      // });
    },
    // 设置白板是否可以涂鸦
    onSetTool(type, active) {
      this.drawEnable = type;
      this.toolActive = active;
      this.teduBoard.setDrawEnable(type);
    },
    // 选择涂鸦工具
    onSetToolType(toolType) {
      if (this.drawEnable) {
        this.toolActive = toolType;
        this.teduBoard.setToolType(toolType);
      }
    },
    // 举手
    onSetHand() {
      if (this.classStatus) {
        const isOnline = this.onlineVideo.find(
          item => item.name === this.studentLiveId
        );
        if (isOnline) {
          this.$message.warning("当前已上台，请勿重复举手!");
        } else {
          this.isHand = !this.isHand;
          if (this.isHand) {
            const text = {
              event: "RAISE_HANDS",
              extra: "学生举手！",
              student_id: this.studentLiveId
            };
            this.tic.sendGroupCustomMessage(JSON.stringify(text)); // 发送举手给老师
            this.$http
              .patch(
                `${this.apiUrl}/api/liveroom/student/${this.liveroomId}/${
                  this.liveroom.student_id
                }/extend_json_status`,
                {
                  extend_json_status: {
                    raise_hands: 1
                  }
                }
              )
              .then(() => {
                console.log("举手上报成功");
              });
          } else {
            const text = {
              event: "CANCEL_RAISE_HANDS",
              extra: "学生取消举手！",
              student_id: this.studentLiveId
            };
            this.tic.sendGroupCustomMessage(JSON.stringify(text)); // 发送取消举手给老师
            this.$http
              .patch(
                `${this.apiUrl}/api/liveroom/student/${this.liveroomId}/${
                  this.liveroom.student_id
                }/extend_json_status`,
                {
                  extend_json_status: {
                    raise_hands: 0
                  }
                }
              )
              .then(() => {
                console.log("举手上报成功");
              });
          }
        }
      } else {
        this.$message.warning("当前不是上课状态，无法举手");
      }
    },
    // 显示隐藏消息框
    onShowMsgBox(type) {
      this.showMsgBox = type;
    },
    // 发送普通文本消息
    sendMsg(text) {
      if (!this.imMsg.common.data) {
        this.$message.error(`不能发送空消息`);
        return;
      }
      // C2C 文本
      if (this.imMsg.common.toUser) {
        this.tic.sendTextMessage(this.imMsg.common.toUser, text, res => {
          if (res.code !== 0) {
            this.showMessageInBox(
              "TIC",
              "sendTextMessage failed, code=" + res.code + " content:" + text
            );
          }
          this.showMessageInBox(
            this.allUser[this.studentLiveId],
            text,
            "left",
            this.studentLiveId
          );
          console.log("===sendTextMessage:", res);
        });
      } else {
        // 群组 文本
        if (!this.liveroomId) {
          this.$message.error("发送群消息时，房间号不能为空");
          return;
        }
        this.tic.sendGroupTextMessage(text, res => {
          if (res.code !== 0) {
            this.showMessageInBox(
              "TIC",
              "sendGroupTextMessage failed, code=" +
                res.code +
                " content:" +
                text
            );
          }
          this.showMessageInBox(
            this.allUser[this.studentLiveId],
            text,
            "left",
            this.studentLiveId
          );
          console.log("===sendTextMessage:", res);
        });
      }
      this.imMsg.common.data = "";
    },
    // 设置直播时间
    setLiveTime(type, beginTime) {
      if (beginTime) {
        const dura =
          this.$moment(new Date()).format("x") -
          this.$moment(beginTime).format("x");
        this.setTimeA = this.$moment.duration(dura / 1000);
      }
      // eslint-disable-next-line no-unused-vars
      const time = setInterval(() => {
        this.setTimeA++;
        this.setTime = this.$setting.secondToDate(this.setTimeA);
      }, 1000);
      if (type === "end") {
        clearInterval(time);
      }
    },
    // 退出课堂
    quitClassroom(callback) {
      if (this.liveroomId) {
        if (this.localStream && this.isPushing) {
          // 如果正在推流, 先停止发布流
          this.stopPush(() => {
            this.trtcClient
              .leave()
              .then(() => {
                console.log("音视频退房成功");
              })
              .catch(error => {
                console.error("退房失败" + error);
              });
          });
        }
        const text = {
          event: "STUDENT_LEAVE_LIVE_ROOM",
          extra: JSON.stringify(this.extra),
          student_id: this.studentLiveId
        };
        // 发送离开直播间消息
        this.tic.sendGroupCustomMessage(JSON.stringify(text), () => {
          this.tic.quitClassroom(res => {
            if (res.code) {
              this.$message.error("退出课堂失败");
              console.log("quitClassroom error" + res.code);
            } else {
              this.$message.success("退出课堂成功");
              this.studentReport(2); // 学生退出直播间上报
              this.status = this.STATUS_LOGINED;
              this.initData();
              this.quitReport(); // 上报退出状态
              this.tic.logout(() => {
                setTimeout(() => {
                  this.$token.remove();
                  this.$router.push(`/?liveroom_id=${this.liveroomId}`);
                }, 1000);
              }); // 登出tic
            }
            callback &&
              callback({
                code: 0
              });
          });
          this.clearClassInfo();
        });
      }
    },
    // 退出按钮
    quit() {
      this.$confirm("是否要退出直播间?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.quitClassroom();
      });
    },
    // 监听离开页面
    beforeunloadHandler(e) {
      console.log("准备离开直播间");
      e.returnValue = "是否要离开直播间？";
    },
    // 离开页面时调用
    unloadHandler() {
      console.log("离开直播间");
      this.quitClassroom();
    },
    // 监听message
    handleMessage(res) {
      console.log("监听message", res);
      switch (res.data.type) {
        // 关闭小工具窗口
        case "closeMachineView":
          this.miniToolUrl = "";
          this.showTool = false;
          break;
        // 发送小工具窗口宽高
        case "getWindowSize":
          // eslint-disable-next-line no-case-declarations
          // const dom = document.querySelector(".miniTool");
          this.$refs.miniTool.contentWindow.postMessage(
            {
              type: "getWindowSize",
              data: {
                width: document.body.offsetWidth,
                height: document.body.offsetHeight
              }
            },
            "*"
          );
          break;
        // 发送小工具分组
        case "getSelfGroup":
          this.$refs.miniTool.contentWindow.postMessage(
            {
              type: "getSelfGroup",
              data: this.group
            },
            "*"
          );
          break;
        // cocos加载完成
        case "loadCompleted":
          this.cocosLoading = false;
          break;
        // 发送cocos配置信息
        case "getCourseRoomInfo":
          // eslint-disable-next-line no-case-declarations
          const data = {
            app: {
              theme: this.courseConfig.theme,
              course: this.courseConfig.course,
              video_json: this.courseConfig.videoJson,
              video_path: this.courseConfig.videoPath
            },
            roomId: this.liveroomId,
            teacherId: this.liveroom.liveroom.teacher_id,
            roleInfo: {
              uuid: this.liveroom.student.uuid,
              sex: this.liveroom.student.gender,
              name: this.liveroom.student.name,
              avatar: this.liveroom.student.headimgurl
            }
          };
          console.log("courseRoomInfo", data);
          this.$refs.cocosIframe.contentWindow.postMessage(
            {
              type: "getCourseRoomInfo",
              playload: data
            },
            "*"
          );
          break;
        // 接收cocos播放完成
        case "videoCompleted":
          console.log("cocos播放完成!!!");
          // this.showCourse = false;
          break;
        // 新课件cocos加载完成
        case "webloadCompleted":
          this.cocosLoading = false;
          break;
        // 发送新课件cocos配置信息
        case "webgetCourseRoomInfo":
          // eslint-disable-next-line no-case-declarations
          const newCourseData = {
            app: {
              theme: this.courseConfig.theme,
              course: this.courseConfig.course,
              video_json: this.courseConfig.videoJson,
              video_path: this.courseConfig.videoPath
            },
            roomId: this.liveroomId,
            teacherId: this.liveroom.liveroom.teacher_id,
            roleInfo: {
              uuid: this.liveroom.student.uuid,
              sex: this.liveroom.student.gender,
              name: this.liveroom.student.name,
              avatar: this.liveroom.student.headimgurl
            }
          };
          console.log("newCourseRoomInfo", newCourseData);
          this.$refs.cocosIframe.contentWindow.postMessage(
            {
              type: "cocosgetCourseRoomInfo",
              value: newCourseData,
              index: res.data.index
            },
            "*"
          );
          break;
        // 接收新课件cocos播放完成
        case "webvideoCompleted":
          console.log("新课件cocos播放完成!!!");
          // this.showCourse = false;
          break;
        default:
          break;
      }
    }
  },
  mounted() {
    window.onbeforeunload = e => this.beforeunloadHandler(e); // 监听页面离开前
    window.onunload = e => this.unloadHandler(e); // 监听页面离开时
    window.onpopstate = () => this.quitClassroom(); // 监听前进后退 离开课堂
    window.onmessage = e => this.handleMessage(e); // 监听iframe回调事件
  }
};
</script>

<style lang="scss">
.live_room {
  width: 100%;
  height: 100%;
  background: #2b2c34;
  margin: 0 auto;
  .header,
  .footer {
    padding: 0;
  }
  .el-main {
    padding: 0;
    .main {
      .live_video_box {
        width: 100%;
        background: #22232a;
        .inner_box {
          width: 177.78vh;
          height: 16.56vh;
          margin: 0 auto;
          display: flex;
          justify-content: center;
          .live_box {
            flex: 0 0 29.63vh;
            width: 29.63vh;
            height: 16.56vh;
            overflow: hidden;
            position: relative;
            video {
              object-fit: cover;
              width: 100%;
              height: 100%;
              left: 0;
            }
            .video {
              width: 29.63vh;
              height: 16.56vh;
              img {
                display: block;
                width: 100%;
                height: 100%;
              }
            }
            .info {
              position: absolute;
              left: 0;
              bottom: 0;
              width: 100%;
              z-index: 10;
              .teacher_info {
                display: block;
                float: left;
                margin-left: 0.74vh;
                margin-bottom: 0.74vh;
                background: rgba(0, 0, 0, 0.3);
                border-radius: 1.85vh;
                height: 2.78vh;
                line-height: 2.78vh;
                font-size: 1.3vh;
                text-align: center;
                padding: 0 1.5vh;
                color: #fff;
                .icon {
                  display: inline-block;
                  vertical-align: middle;
                  width: 0.56vh;
                  height: 0.56vh;
                  background: #ff5454;
                  margin-right: 0.5vh;
                  border-radius: 50%;
                  &.active {
                    background: #3fe0bc;
                  }
                }
              }
              .audio {
                display: block;
                float: right;
                margin-right: 0.74vh;
                margin-bottom: 0.74vh;
                background: rgba(0, 0, 0, 0.3);
                border-radius: 1.85vh;
                height: 2.78vh;
                line-height: 2.78vh;
                font-size: 1.3vh;
                text-align: center;
                padding: 0 1.5vh;
                color: #fff;
                img {
                  display: inline-block;
                  vertical-align: middle;
                  width: 1.5rem;
                  height: auto;
                }
              }
            }
            .teacher_live_video {
              width: 100%;
              height: 100%;
              background: url("../../assets/images/live_room/icon_video_error.png")
                center center no-repeat;
              background-size: 3.7vh 3.23vh;
              .teacher_live_video_main {
                div {
                  width: 29.63vh !important;
                  height: 16.56vh !important;
                  background: none !important;
                  video {
                    left: 0;
                  }
                }
              }
            }
            .video_box {
              width: 29.63vh;
              height: 16.56vh;
              background: url("../../assets/images/live_room/icon_video_error.png")
                center center no-repeat;
              background-size: 3.7vh 3.23vh;
            }
            .video_error {
              width: 3.7vh !important;
              height: 3.23vh !important;
              display: block;
              margin: 6vh auto 0;
            }
          }
          .my_video {
            display: none;
          }
        }
      }
      .live_info_box {
        width: 177.78vh;
        height: 79.72vh;
        margin: 0 auto;
        position: relative;
        .student_sign {
          width: 141.48vh;
          height: 79.72vh;
          background: #1d1d1d;
          position: absolute;
          z-index: 11;
          left: 50%;
          transform: translate(-50%, 0px);
          .title {
            color: #fff;
            text-align: center;
            margin-top: 30vh;
            h1 {
              font-size: 1.85vh;
            }
            h2 {
              font-size: 1.48ch;
              margin-top: 1.85vh;
              color: #b3b3b3;
            }
          }
          .count_down {
            margin-top: 1.85vh;
            .time {
              display: flex;
              width: 39vh;
              margin: 0 auto;
              div {
                flex: 0 0 3.8vh;
                width: 3.8vh;
                height: 5.56vh;
                line-height: 5.56vh;
                background: rgba(255, 255, 255, 0.13);
                border-radius: 0.37vh;
                font-size: 3.15vh;
                color: #fff;
                margin: 0 1vh;
                &.center {
                  background: none;
                  color: #fff;
                  font-weight: bold;
                  flex: 0 0 2vh;
                  width: 2vh;
                  margin: 0;
                  text-align: center;
                }
              }
            }
          }
          .btn {
            width: 20vh;
            height: 3.7vh;
            line-height: 3.7vh;
            margin: 2.96vh auto 0;
            background: #ffca4a;
            font-size: 1.48vh;
            font-weight: bold;
            color: #333;
            border-radius: 4.07vh;
            &.click {
              cursor: pointer;
            }
          }
        }
        .course_box {
          margin: 0 auto;
          width: 141.48vh;
          height: 79.72vh;
          background: #fff;
          position: relative;
          display: block;
          &.minimize {
            display: none;
          }
          &.maximize {
            position: fixed;
            left: 50%;
            top: 0;
            z-index: 11;
            transform: translate(-50%, 0);
            height: 100vh;
            width: 177.777vh;
          }
          .box {
            width: 100%;
            height: 100%;
            margin: 0 auto;
            /*background: #fff;*/
            &.cocos {
              position: absolute;
              left: 0;
              top: 0;
              z-index: 11;
            }
            &.white_board {
              position: absolute;
              left: 50%;
              top: 50%;
              transform: translate(-50%, -50%);
              z-index: 10;
              background: #fff;
              &.draw_enable {
                canvas {
                  cursor: default !important;
                }
              }
            }
            iframe {
              display: block;
              width: 100%;
              height: 100%;
            }
          }
          .miniTool {
            width: 100%;
            height: 100%;
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
            z-index: 20;
            iframe {
              width: 100%;
              height: 100%;
            }
          }
          .cocos_loading {
            width: 100%;
            height: 100%;
            display: block;
            position: absolute;
            left: 0;
            top: 0;
            z-index: 21;
            img {
              display: block;
              width: 100%;
              height: 100%;
            }
          }
          .teacher_live_video_aux {
            width: 100%;
            height: 100%;
            display: block;
            position: absolute;
            left: 0;
            top: 0;
            z-index: 22;
            .aux_main {
              display: block;
              width: 100%;
              height: 100%;
              div {
                width: 100%;
                height: 100%;
                video {
                  left: 0;
                }
              }
            }
          }
        }
      }
    }
  }
  .dialog {
    /deep/ .el-dialog__header {
      display: none;
    }
  }
}
</style>
